'use client'

import { useState, useRef, useEffect } from 'react'
import { CONTACTUS_COMPONENTS_MAPPING } from '@configs/contactus.config'
import AssistBot from '@components/AckoAssistBot/AssistBot'
import styles from './Globalstyle.module.scss'

const ContactUsView = ({ contents, isMobile, envConfig }) => {
  const botRef = useRef<any>(null)
  useEffect(() => {
    if (botRef.current) {
      botRef.current.setCopilotContext({ page: 'Contact Us' })
    }
  }, [])
  const [isModalOpen, setIsModalOpen] = useState(false)

  const triggerCopilot = (message: string | undefined) => {
    if (message?.length) {
      botRef.current.sendCopilotMessage(message)
    } else {
      botRef.current.openCopilot()
    }
  }
  const handleModalOpen = flag => {
    setIsModalOpen(flag)
    botRef.current?.closeCopilot()
  }
  const { UID } =
    contents?.find(component => component.__component === 'contact-us.contact-channel')?.contact_channel?.data
      ?.attributes || {}
  return (
    <div className={styles.parentContainer}>
      {contents?.map(componentData => {
        const componentName = componentData.__component
        const Component = CONTACTUS_COMPONENTS_MAPPING[componentName]
        if (Component) {
          return (
            <Component
              key={componentData.id + componentName}
              {...componentData}
              isMobile={isMobile}
              isModalOpen={isModalOpen}
              handleModalOpen={handleModalOpen}
              triggerCopilot={triggerCopilot}
              uid={UID}
            />
          )
        }
        return null
      })}
      <AssistBot ref={botRef} hideFAB={isModalOpen} envConfig={envConfig} />
    </div>
  )
}

export default ContactUsView
